import React, { useRef, useState } from 'react';

import PropTypes from 'prop-types';
import style from './DownloadInvoice.module.scss';
import { DefaultErrMsg, isValidEmail } from '../../lib/common';
import { server } from '../../config';
import { PostGenericApiCall } from '../../api';
import useClickAwayListener from '../../hooks/useClickAwayLitsner';

const DownloadInvoice = (props) => {
  const { invoData, selectedBusinessData, setGenInvoClick, setAlert, genInvoClick } = props;
  const selectedInvoType = genInvoClick?.invoType === 'ecsinvoice' ? 'ecs_invoice' : 'htmlInvoice_new';
  const [invSelect, setInvSelect] = useState({});
  const [emailData, setEmailData] = useState('');
  const modelRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const downloadInvoice = () => {
    if (!invSelect?.instrumentId || !invSelect?.invoice_number) {
      setAlert({ message: 'Please select an invoice to download', status: false });
      return;
    }

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${server.apiURL}csportal/fetchInvoicePdf`;

    const fields = {
      parentid: selectedBusinessData.parentid,
      instrumentId: invSelect.instrumentId,
      invoice_number: invSelect.invoice_number,
      invoType: selectedInvoType,
    };

    Object.entries(fields).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);

    setAlert({ message: 'Invoice download started', status: true });
  };

  const shareInvoice = async () => {
    document.body.style.overflow = 'unset';
    const url = `${server.apiURL}csportal/shareInvoicePdf`;
    const validEmail = isValidEmail(emailData);
    if (validEmail) {
      const commsData = {
        email_id: emailData,
        parentid: selectedBusinessData.parentid,
        instrumentid: invSelect?.instrumentId || '',
        entity_type: selectedInvoType === 'ecs_invoice' ? 'ecs' : 'nonecs',
      };
      const comData = await PostGenericApiCall(url, commsData);
      if (comData?.errorCode === 0) {
        setAlert({ message: comData?.message || 'Communication sent successfully', status: true });
      } else {
        setAlert({ message: comData?.message || DefaultErrMsg, status: false });
      }
      setGenInvoClick({ clicked: false, invoData: [] });
    } else {
      setAlert({ message: 'Invalid email id entered' || DefaultErrMsg, status: false });
    }
  };

  const invoCheck = async (e, item, idx) => {
    if (e?.target?.checked) {
      setInvSelect(item);
      setSelectedIndex(idx);
    } else {
      setInvSelect({});
      setSelectedIndex(null);
    }
  };

  useClickAwayListener(modelRef, () => {
    document.body.style.overflow = 'unset';
    setGenInvoClick({ clicked: false, invoData: [] });
  });
  const disableBtn = !invSelect || Object.keys(invSelect).length === 0;
  return (
    <>
      <section className={`cs_modal ${style.DownloadInvoice}`}>
        <div ref={modelRef} className={`cs_modal_content cs_modal_animation cs_modal_up ${style.Content}`}>
          <div className="cs_modal_header pt-20 pl-20 pr-20 pb-20">
            <div className={`cs_modal_head_center text_left  ${style.HeadCenter}`}>
              <div className={`font16 fw600 color111 `}>Download Recent Invoice</div>
            </div>
            <div className="cs_modal_head_right">
              <div
                className={`${style.Close} cs_modal_close csicon`}
                onKeyDown={() => {}}
                tabIndex={0}
                role="button"
                aria-label="close"
                onClick={() => {
                  document.body.style.overflow = 'unset';
                  setGenInvoClick({ clicked: false, invoData: [] });
                }}
              />
            </div>
          </div>
          <div className={`${style.Body} cs_modal_body pl-20 pr-20 pb-20`}>
            <ul className={`${style.List}`}>
              <li className={`${style.Item} ${style.ItemHead}`}>
                <div className={`${style.ItemLabel} font13 fw400 color777`}>Deal Date</div>
                <div className={`${style.ItemText} font13 fw400 color777`}>Amount</div>
              </li>
              {invoData?.map((item, idx) => (
                <li className={`${style.Item}`} key={`download-${idx}`}>
                  <div className={`${style.ItemLabel}`}>
                    <label className={` ${style.Checkbox__Lable}`} htmlFor={`checkbox-invo-${idx}`}>
                      <input
                        className={`${style.Checkbox__Input} `}
                        type="checkbox"
                        id={`checkbox-invo-${idx}`}
                        onClick={(e) => invoCheck(e, item, idx)}
                        checked={selectedIndex === idx}
                        readOnly
                      />
                      <span className={`${style.Checkbox__Icon} csicon `} />
                      <span className={` ${style.Checkbox__Text} font13 fw500 color111 pl-10`}>
                        {item?.clearance_date || '--'}{' '}
                      </span>
                    </label>
                  </div>
                  <div className={`${style.ItemText} font13 fw500 color111`}>₹{item?.instrument_amount}</div>
                </li>
              ))}
            </ul>
            <div className={`${style.InputBox} mt-20`}>
              <div className="font14 fw500 color111">Share on Email</div>
              <div className={`${style.InputGroup} mt-12`}>
                <input
                  className={`${style.Input} font13 fw400 color111`}
                  type="email"
                  placeholder="Enter Email Id"
                  onChange={(e) => setEmailData(e.target.value)}
                />
                <button
                  disabled={!emailData}
                  className={`${style.InputButton} ${emailData ? 'blue_whitefill_animate' : ''} font13 fw400 color007`}
                  type="button"
                  onClick={() => shareInvoice()}
                >
                  Share
                </button>
              </div>
            </div>
          </div>
          <div className={`${style.ButtonGroup}`}>
            <button
              disabled={disableBtn}
              className={`${style.Button} ${!disableBtn ? 'bluefill_animate' : ''} font14 fw600 colorFFF`}
              type="button"
              onClick={() => downloadInvoice()}
            >
              Download
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

DownloadInvoice.propTypes = {
  invoData: PropTypes.any,
  selectedBusinessData: PropTypes.any,
  setGenInvoClick: PropTypes.func,
  setAlert: PropTypes.func,
  genInvoClick: PropTypes.object,
};

export default DownloadInvoice;
